/*
 * Routes-restaurants.ts
 * Description: Includes the declaration of the
 * restaurant routes for Vue Router
 */

// Importing components
import PageRestaurants from '@/pages/restaurants/PageRestaurants.vue';
import PageRestaurantPreview from '@/pages/PageRestaurantPreview.vue';
import PageRestaurantsCreate from '@/pages/restaurants/PageRestaurantsCreate.vue';
import PageRestaurantsUpdate from '@/pages/restaurants/PageRestaurantsUpdate.vue';
import PageTowns from '@/pages/restaurants/PageTowns.vue';
import PageAdvancedSearch from '@/pages/PageAdvancedSearch.vue';

const routesRestaurants = [
    // Defining the restaurants page route
    {
        path: '/restaurants',
        name: 'restaurants',
        component: PageRestaurants,
        meta: { requiresAuth: true, ManageSystem: true },
    },
    // Defining the restaurant preview page route
    {
        path: '/restaurants/search',
        name: 'restaurants-preview',
        component: PageRestaurantPreview,
    },
    // Defining the restaurant advanced search route
    {
        path: '/restaurants/search/advanced',
        name: 'restaurants-search',
        component: PageAdvancedSearch,
        props: { tag: String, ekatte: String },
    },
    // Defining the restaurants create page route
    {
        path: '/restaurants/create',
        name: 'restaurants-create',
        component: PageRestaurantsCreate,
        meta: { requiresAuth: true, CreateRestaurants: true },
    },
    // Defining the restaurants update page route
    {
        path: '/restaurants/:id/update',
        name: 'restaurants-update',
        component: PageRestaurantsUpdate,
        props: { id: Number },
        meta: { requiresAuth: true, EditRestaurants: true },
    },
    // Defining the towns page route
    {
        path: '/restaurants/:id/towns',
        name: 'towns',
        component: PageTowns,
        props: { id: Number },
        meta: { requiresAuth: true, EditRestaurants: true },
    },
];
export default routesRestaurants;
